import React from "react";
import { Routes, Route } from "react-router-dom";
import { globalStyles } from './theme/globalStyles';
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Events from "./pages/Events";
import Sponsor from "./pages/Sponsor";
import RiverHacks from "./pages/RiverHacks";
import CssBaseline from '@mui/material/CssBaseline';
import MainLayout from './layouts/MainLayout';
import { ThemeProvider } from './theme/ThemeContext';
import ScrollToTop from './components/ScrollToTop';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

const App = () => (
  <ThemeProvider>
    <CssBaseline />
    {globalStyles}
    <ScrollToTop />
    <MainLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/riverhacks" element={<RiverHacks />} />
        <Route path="/events" element={<Events />} />
        <Route path="/sponsor" element={<Sponsor />} />
      </Routes>
    </MainLayout>
    <SpeedInsights />
    <Analytics />
  </ThemeProvider>
);

export default App;